/**
 * Generate and download a csv file
 * @constructor
 * @param {string} name - File name to download
 * @param {string} data - Csv content
 */
// Excel solo reconoce el archivo como UTF-8 si parte con el BOM, si no rompe los acentos
const BOM = "﻿";

function generateCsv({ name, data }) {
    let csvFile = new Blob([BOM + data], { type: "text/csv;charset=utf-8;" });
    let downloadLink = document.createElement("a");
    downloadLink.download = name || "atentus-file";
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";

    document.body.appendChild(downloadLink);
    downloadLink.click();
}

export { generateCsv };
